export default "__VITE_ASSET__CDo8ulV7__"